import { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { Button, Modal, Input, Space, Collapse, Layout, List, RadioChangeEvent, ConfigProvider, Radio, Alert } from 'antd';
import {
  FrownOutlined,
} from '@ant-design/icons';
import { API_ENDPOINTS } from '../../frameWork/utils/keyapi-endpoints';
import { useAddQuery, useGetQuery } from '../../frameWork/rest';
import './dashboard.css'
import FeatherIcons from 'feather-icons-react';
import { useDispatch, useSelector } from 'react-redux';
import { changeFlterAddAction } from '../../redux/actions';
import { useLocation } from 'react-router-dom';
import { retLastSegmentURL } from '../../utils/retLastSegmentURL';
import _ from 'underscore';

const { Content } = Layout;

interface mytype { modalOpen: boolean, setDialogOpen: any }

const FilterGeneratorDialog = ({ modalOpen, setDialogOpen }: mytype) => {




  const dispatch = useDispatch();
  const location = useLocation();
  const [dataSourceId, setDataSourceId] = useState<any>([])
  const [columnInDataSource, setColumnInDataSource] = useState<any>([])
  const [selectedDataSource, setSelectedDataSource] = useState<any>({})
  const [selectedCol, setSelectedCol] = useState<any>({})

  const [myDataFilter, setMyDataFilter] = useState<any>([])
  const [value, setValue] = useState(1);
  const { isLoading, chartList: ChartListPage, config } = useSelector((state: any) => state.DashboardPage, _.isEqual);

  const { isLoading: isloadingsd, data: DataSourecList, refetch: getAllDataSourceList } = useGetQuery(API_ENDPOINTS.DATASOURCE, API_ENDPOINTS.DATASOURCE);
  const { mutateAsync: getCubeByQuerySelectFilter, data: dataFilter, isLoading: ii }: any = useAddQuery(API_ENDPOINTS.CUBE_GET_FILTERQUERY, "");
  const [errorMessage, setErrorMessage] = useState("")

  // useEffect(()=>{
  //   getAllMenuTreeList()
  // },[])
  const onSubmitForm = async (values: any) => {
    let c: any = {
      sMenuPageId: retLastSegmentURL(location?.pathname),
      sDataSourceId: selectedDataSource?.id,
      //tableName:selectedDataSource.tableName,
      colName: selectedCol.name,
      title: selectedCol.name,
      filterType: value
    }

    // this.href.substring(this.href.lastIndexOf('/') + 1)

    // postFilterMenu(c)
    await dispatch(changeFlterAddAction({ item: c, pageId: retLastSegmentURL(location?.pathname) }))

    setDialogOpen(false)
  }


  const formik = useFormik({
    initialValues: {

      label: '',
      parentId: '',
      icon: '',
      url: ''
    },
    // validationSchema: Yup.object({
    //   label: Yup.string().required('نام را وارد نمائید'),
    // }),
    onSubmit(values) {
      onSubmitForm(values);
    },
  });

  const CloseHandlingModal = () => {
    setDialogOpen();
    formik.resetForm();
  }

  useEffect(() => {
    //getAllChartList();
    const c = async () => {
      await getAllDataSourceList();
    }
    c()
  }, [modalOpen]);

  function onlyUnique(value: any, index: any, array: any) {
    return array.indexOf(value) === index;
  }

  useEffect(() => {
    const c = ChartListPage
    let datasourceList = [];
    var cc = c?.map((x: any) => JSON.parse(x.details).datasourceId)
    var cc1 = c?.map((x: any) => JSON.parse(x.details))
    const dataSourceIdList = cc?.filter(onlyUnique)
    let arr = DataSourecList?.filter(function (item: any) {
      return dataSourceIdList.indexOf(item.id) !== -1;
    });
    let aa = arr?.map((a: any) => ({ ...a, isSelect: false }))
    setDataSourceId(aa)
  }, [DataSourecList]);

  useEffect(() => {
    setMyDataFilter(dataFilter);
  }, [dataFilter])






  const setNodeIcon = (typeIcon: string, color: string) => {
    switch (typeIcon) {
      case "char":
      case "nchar":
      case "nvarchar":
      case "varchar":
      case "text":
        return <FeatherIcons className="icon-dual icon-xs" icon={'type'} style={{ color: color }} />

      case "int":
      case "smallint":
      case "bigint":
      case "float":
      case "real":
      case "decimal":
      case "decimal(18,2)":
      case "numeric":
        return <FeatherIcons className="icon-dual icon-xs" icon={'hash'} style={{ color: color }} />

      case "date":
      case "datetime":
      case "datetimeoffset":
      case "smalldatetime":
        return <FeatherIcons className="icon-dual icon-xs" icon={'calendar'} style={{ color: color }} />

      case "bit":
        return <FeatherIcons className="icon-dual icon-xs" icon={'check-square'} style={{ color: color }} />

      default:
        return <FeatherIcons className="icon-dual icon-xs" icon={'database'} style={{ color: color }} />
    }
  }

  const onHandlerSelect = async (index: any) => {
    let newArr = [...columnInDataSource];
    newArr.map((c: any) => c.isSelect = false);
    newArr[index].isSelect = true;
    await getCubeByQuerySelectFilter({ "datasourceId": selectedDataSource?.id, "filterCol": newArr[index].name, "newFields": [], start: 0, limit: 100, whereQuery: '' });
    setSelectedCol(newArr[index])
    setColumnInDataSource(newArr)
  }

  const onHandlerSelectDataSource = (index: any) => {
    let newArr = [...dataSourceId];
    newArr.map((c: any) => c.isSelect = false);
    newArr[index].isSelect = true;
    let colSchema = JSON.parse(newArr[index].schema)
    let aa = colSchema?.map((a: any) => ({ ...a, isSelect: false }))

    setSelectedDataSource(newArr[index])
    setDataSourceId(newArr)
    setColumnInDataSource(aa)
  }



  const onChange = (e: RadioChangeEvent) => {
    setValue(e.target.value);
  };

  const customizeRenderEmpty = () =>

    !ii && (
      <div style={{ textAlign: 'center' }}>
        <FrownOutlined style={{ fontSize: 20 }} />
        <p style={{ textAlign: 'center' }}>داده ای برای نمایش وجود ندارد</p>
      </div>
    );

  return (
    <Modal
      width={700}
      style={{ position: 'relative', height: 'calc(100vh - 300px)' }}
      styles={{ body: { overflowY: 'scroll' } }}
      zIndex={1050}
      maskClosable={false}
      destroyOnClose
      open={modalOpen}
      afterClose={CloseHandlingModal}
      title="افزودن فیلتر"
      onCancel={setDialogOpen}
      okText="ذخیره"
      cancelText="انصراف"
      footer={
        [
          <Button key="back" onClick={CloseHandlingModal}>
            انصراف
          </Button>,
          <Button
            key="submit"
            type="primary"
            disabled={dataFilter === undefined || dataFilter?.length === 0}
            //loading={isPostingMenu}
            onClick={() => {
              formik.handleSubmit();
            }}
          >
            ذخیره
          </Button>,
        ]
      }
    >
      <Layout style={{ display: 'flex', flexDirection: 'row' }} >
        {errorMessage != "" && <Alert onClose={() => setErrorMessage("")} style={{ width: '100%', marginBottom: 5 }} message={errorMessage} type="error" closable />}

        <Content style={{ height: 420, width: 100 }}>
          <div className='pane'>
            <div className='header' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingRight: 0 }}>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                انتخاب منبع داده
              </div>
              {/* <TbAxisX style={{ fontSize: 20, color: "rgb(74 74 74 / 85%)" }} /> */}
            </div>
            <div style={{ height: 360, flexDirection: 'column', justifyContent: 'flex-start', padding: 3, margin: 1 }} className='sss'>
              {dataSourceId && dataSourceId.map((item: any, index: any) =>
                <div key={index} style={{ width: '100%', backgroundColor: item.isSelect ? '#27ae60' : '#fff' }} className="fieldContainer" onClick={() => onHandlerSelectDataSource(index)}>
                  <div className='fieldContainerPopover' >
                    <span style={{ fontSize: 12, color: item.isSelect ? '#fff' : '#979a9d' }}>{item.name}</span>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <Button style={{ width: 20 }} onClick={() => { }} type="link" />
                    </div>
                  </div>
                </div>
              )}

              {/* <div style={{ textAlign: 'center', width:'100%' }} className="alert alert-warning" role="alert">
                منبع داده ای  وجود ندارد
              </div>               */}
            </div>
          </div>
        </Content>
        <Content style={{ height: 420, width: 100 }}>
          <div className='pane'>
            <div className='header' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingRight: 0 }}>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                انتخاب فیلتر
              </div>
              {/* <TbAxisX style={{ fontSize: 20, color: "rgb(74 74 74 / 85%)" }} /> */}
            </div>
            <div style={{ height: 360, flexDirection: 'column', justifyContent: 'flex-start', padding: 3, margin: 1 }} className='sss todos'>
              {columnInDataSource?.length > 0 ? columnInDataSource?.map((item: any, index: any) => (
                <div key={index} style={{ width: '100%', backgroundColor: item.isSelect ? '#27ae60' : '#fff' }} className="fieldContainer" onClick={() => onHandlerSelect(index)}>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '100%'
                  }}>
                    <div className='containerField' style={{ backgroundColor: 'transparent' }}>
                      {setNodeIcon(item.type, item.isSelect ? '#fff' : '#979a9d')}
                    </div>
                    <span style={{ marginRight: '0.3rem', color: item.isSelect ? '#fff' : '#979a9d' }}>{item.name}</span>
                  </div>
                </div>
              )) :
                <div style={{ textAlign: 'center', width: '100%' }} className="alert alert-info" role="alert">
                  منبع داده انتخاب نشده است
                </div>
              }

            </div>
          </div>
        </Content>
        <Content style={{ height: 420, width: 100 }}>
          <div className='pane'>
            <div className='header' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingRight: 0 }}>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                تنظیمات فیلتر
              </div>
              {/* <TbAxisX style={{ fontSize: 20, color: "rgb(74 74 74 / 85%)" }} /> */}
            </div>
            <div style={{ height: 360, flexDirection: 'column', justifyContent: 'flex-start', padding: 3, margin: 1 }} className='sss'>
              <div id="scrollableDiv" className="filterContent" style={{ marginTop: 5, display: 'flex', border: "1px solid #d3d2d2", borderRadius: 5, padding: 5, minHeight: 150, overflowY: 'auto', maxHeight: 150, width: '100%' }}>
                <ConfigProvider renderEmpty={customizeRenderEmpty}>
                  <List
                    size="small"
                    dataSource={dataFilter}
                    renderItem={(item: any) => <List.Item style={{ padding: 0, border: 'none', fontSize: 12, width: '100%' }}>{item.filterCol}</List.Item>}
                  />
                </ConfigProvider>
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', width: '100%', border: '1px solid rgb(211, 210, 210)', borderRadius: 5, marginTop: 5 }}>
                <span style={{ padding: 10, borderBottom: '1px solid #d3d2d2' }}>نوع فیلتر :</span>
                <Radio.Group onChange={onChange} value={value}>
                  <Space direction="vertical">
                    <Radio style={{ fontSize: 12, fontWeight: 400 }} value={1}>Select</Radio>
                    <Radio style={{ fontSize: 12, fontWeight: 400 }} value={2}>Multi Select</Radio>
                    <Radio style={{ fontSize: 12, fontWeight: 400 }} value={3}>Radio</Radio>
                    <Radio style={{ fontSize: 12, fontWeight: 400 }} value={4}>List</Radio>
                    <Radio style={{ fontSize: 12, fontWeight: 400 }} value={5}>Date</Radio>
                  </Space>
                </Radio.Group>
              </div>

              {/* <div style={{ textAlign: 'center', width: '100%' }} className="alert alert-warning" role="alert">
                فیلتر انتخاب نشده است
              </div> */}
            </div>
          </div>
        </Content>
      </Layout>
    </Modal>
  );
};

export default FilterGeneratorDialog;
